import PropTypes from 'prop-types';
import React from 'react';
import { MailIcon } from '../../../components/Icons';
import { cleanUrl, isUrlAnEmail } from '../../../utils/linkUtils';
export default function BaseLinkDecorator(_ref) {
  var rawUrl = _ref.url,
      onMouseDown = _ref.onMouseDown,
      onClick = _ref.onClick,
      children = _ref.children,
      attributes = _ref.attributes;
  var url = cleanUrl(rawUrl);
  return React.createElement("a", Object.assign({
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onClick,
    onMouseDown: onMouseDown,
    className: "pointer font-weight-medium primary underline-on-hover"
  }, attributes), isUrlAnEmail(rawUrl) && React.createElement(MailIcon, {
    size: 12,
    className: "margin-right-smaller"
  }), children);
}
BaseLinkDecorator.propTypes = {
  url: PropTypes.string,
  attributes: PropTypes.object,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onRemove: PropTypes.func
};